module.exports = __webpack_public_path__ + "media/images/ro-44ce57b8fa6b311b0162cf9f4ffa1071.png";